import { render, staticRenderFns } from "./WhatsAppCampaignsCard.vue?vue&type=template&id=5c25e78a&scoped=true"
import script from "./WhatsAppCampaignsCard.vue?vue&type=script&lang=js"
export * from "./WhatsAppCampaignsCard.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppCampaignsCard.vue?vue&type=style&index=0&id=5c25e78a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c25e78a",
  null
  
)

export default component.exports